<template>

    <accordion-input :accordion="accordion" :spacing="spacing" :open="open">
        <template #label>

            <div class="font-medium">{{ label }}</div>

        </template>
        <template #content>

            <small v-if="instruction" class="block mb-3 text-gray-500 text-muted">
                {{ instruction }}
            </small>

            <div class="mt-1">

                <button v-show="colors !== null"
                        v-for="color in colors"
                        :style="{ background: color !== 'transparent' ? color : '' }"
                        class="w-8 h-8 inline-block mr-1 cursor-pointer shadow-sm border focus:outline-none focus:ring-blue-600 focus:border-blue-600 sm:text-sm border-gray-300 rounded-md"
                        :class="{ selected: color === currentColor, checkered: color === 'transparent' }"
                        @click="setValue(color)"/>

                <button v-show="colors === null"
                        v-for="index in 6"
                        class="bg-gray-200 animate-pulse w-8 h-8 inline-block mr-1 cursor-not-allowed shadow-sm border sm:text-sm border-gray-300 rounded-md"
                />

            </div>

        </template>
    </accordion-input>

</template>

<script>

import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";

export default {

    components: {
        AccordionInput
    },

    props: {

        label: {
            type: String,
            required: true,
        },
        instruction: String,

        spacing: {
            horizontal: {
                type: Boolean,
                default: true
            },
            vertical: {
                type: Boolean,
                default: true
            }
        },

        accordion: {
            type: Boolean,
            default: true
        },

        open: {
            type: Boolean,
            default: null
        },

        options: {
            type: Object,
            required: true,
        },
        optionsProperty: {
            required: true,
        },

        colors: {
            type: Array,
        },

        defaultColor: {},
    },

    data() {
        return {
            isOpen: this.open || false,
        }
    },

    methods: {

        setValue(value) {
            // Set in options.
            this.$set(this.options, this.optionsProperty, value);

            // Emit for whoever wants to know.
            this.$emit('colorChange');
        }

    },

    computed: {

        currentColor() {
            // Get value from options.
            let value = this.options[this.optionsProperty];

            // Use value of default value?
            return value === undefined ? this.defaultColor : value;
        },

    },

}

</script>

<style lang="scss" scoped>

.selected {
    @apply shadow-sm ring-blue-600 border-blue-600;
}

.checkered {
    background:                linear-gradient(45deg, rgba(0, 0, 0, 0.0980392) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.0980392) 75%, rgba(0, 0, 0, 0.0980392) 0), linear-gradient(45deg, rgba(0, 0, 0, 0.0980392) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.0980392) 75%, rgba(0, 0, 0, 0.0980392) 0), white;
    background-repeat:         repeat, repeat;
    background-position:       0 0, 5px 5px;
    -webkit-transform-origin:  0 0 0;
    transform-origin:          0 0 0;
    -webkit-background-origin: padding-box, padding-box;
    background-origin:         padding-box, padding-box;
    -webkit-background-clip:   border-box, border-box;
    background-clip:           border-box, border-box;
    -webkit-background-size:   10px 10px, 10px 10px;
    background-size:           10px 10px, 10px 10px;
    -webkit-transform:         scaleX(1) scaleY(1) scaleZ(1);
    transform:                 scaleX(1) scaleY(1) scaleZ(1);
}

</style>
